import { MatDialogRef } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { CommonDialogsService } from 'idk/widgets/common-dialogs/common-dialogs.service';
import { ProgressDialogComponent } from 'idk/widgets/common-dialogs/progress-dialog/progress-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class ProgressIndicatorService {
    private _timer: any;

    private readonly timeout: number = 2000;

    private _progress: MatDialogRef<ProgressDialogComponent> = null;

    private _tokens: any[] = [];

    public constructor(private _dialog: CommonDialogsService) {}

    public show(token: any, force: boolean = false, message: string = null): void {
        if (this._tokens.length == 0) {
            if (force) {
                this._progress = this._dialog.progress(message);
            } else {
                this._timer = setTimeout(() => {
                    this._progress = this._dialog.progress(message);
                    this._timer = null;
                }, this.timeout);
            }
        }

        this._tokens.push(token);
    }

    public hide(token: any): void {
        const index: number = this._tokens.indexOf(token);
        if (index >= 0) {
            this._tokens.splice(index, 1);

            if (this._tokens.length == 0) {
                clearTimeout(this._timer);
                this._timer = null;

                this._progress?.close();
                this._progress = null;
            }
        }
    }

    public error(message: string, callback?: () => void): void {
        this._dialog.error(message, callback);
    }

    public for(action: (complete: () => void) => void, force: boolean = true) {
        const token = {};
        this.show(token, force);
        action(() => this.hide(token));
    }
}
